// extracted by mini-css-extract-plugin
module.exports = {"link":"logo_link__k0dO0"};